import { useQuery } from '@tanstack/vue-query'
import { getApi } from "./api";
export default (accountId: number, userId: number) => useQuery({
    queryKey: ['account-user', accountId, userId],
    queryFn: () => {
        const { api, baseURL } = getApi();
        return api.get(`api/v2/accounts/${accountId}/users/${userId}`, { baseURL }).then(res => res.data.data);
    },
})
